import React, { useState, useEffect, useCallback } from 'react';
import Loader from './components/Loader';
import Background from './components/Background';
import SlideWrapper from './components/SlideWrapper';
import Controls from './components/Controls';
import TTSButton from './components/TTSButton';
import PDFExport from './components/PDFExport';
import Slide01Hero from './slides/Slide01Hero';
import Slide02About from './slides/Slide02About';
import Slide03Vision from './slides/Slide03Vision';
import Slide04Values from './slides/Slide04Values';
import Slide05Highlights from './slides/Slide05Highlights';
import Slide06Chain from './slides/Slide06Chain';
import Slide07Packages from './slides/Slide07Packages';
import Slide08Income from './slides/Slide08Income';
import Slide09Distribution from './slides/Slide09Distribution';
import Slide10X6Board from './slides/Slide10X6Board';
import Slide11DirectIncome from './slides/Slide11DirectIncome';
import Slide12LevelIncome from './slides/Slide12LevelIncome';
import SlideBCoin from './slides/SlideBCoin';
import SlidePayment from './slides/SlidePayment';
import SlidePool1 from './slides/Slide13Pool1';
import SlidePool2 from './slides/Slide14Pool2';
import SlidePool3 from './slides/Slide15Leadership';
import SlidePool4 from './slides/Slide16Pool4';
import SlideNFT from './slides/Slide16NFT';
import SlideCeiling from './slides/Slide17Ceiling';
import SlideRetopup from './slides/Slide18Retopup';
import SlidePartners from './slides/Slide20Partners';
import SlideUserJourney from './slides/Slide19UserJourney';
import SlideTerms from './slides/Slide20Terms';
import SlideSummary from './slides/Slide21Summary';
import SlideCTA from './slides/Slide22CTA';
import SlideThankYou from './slides/Slide23ThankYou';
import './styles/app.css';
import './styles/responsive.css';

const TOTAL_SLIDES = 27;

export default function App() {
  const [loading, setLoading] = useState(true);
  const [loadProgress, setLoadProgress] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [language, setLanguage] = useState('en');
  const [transitioning, setTransitioning] = useState(false);
  const [direction, setDirection] = useState(1);

  useEffect(() => {
    let p = 0;
    const iv = setInterval(() => {
      p += Math.random() * 12 + 3;
      if (p >= 100) { p = 100; clearInterval(iv); setTimeout(() => setLoading(false), 800); }
      setLoadProgress(Math.min(100, Math.floor(p)));
    }, 120);
    return () => clearInterval(iv);
  }, []);

  const [pdfMode, setPdfMode] = useState(false);

  const goTo = useCallback((idx, instant) => {
    if (idx === currentSlide || idx < 0 || idx >= TOTAL_SLIDES) return;
    if (instant) {
      setDirection(idx > currentSlide ? 1 : -1);
      setCurrentSlide(idx);
      setTransitioning(false);
      return;
    }
    if (transitioning) return;
    setDirection(idx > currentSlide ? 1 : -1);
    setTransitioning(true);
    setTimeout(() => {
      setCurrentSlide(idx);
      setTimeout(() => setTransitioning(false), 100);
    }, 600);
  }, [currentSlide, transitioning]);

  const next = useCallback(() => goTo(currentSlide + 1), [currentSlide, goTo]);
  const prev = useCallback(() => goTo(currentSlide - 1), [currentSlide, goTo]);

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown' || e.key === ' ') { e.preventDefault(); next(); }
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); prev(); }
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [next, prev]);

  // Touch swipe
  useEffect(() => {
    let sx = 0, sy = 0;
    const ts = (e) => { sx = e.touches[0].clientX; sy = e.touches[0].clientY; };
    const te = (e) => {
      const dx = e.changedTouches[0].clientX - sx;
      const dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 50) {
        if (dx < 0) next(); else prev();
      }
    };
    window.addEventListener('touchstart', ts, { passive: true });
    window.addEventListener('touchend', te, { passive: true });
    return () => { window.removeEventListener('touchstart', ts); window.removeEventListener('touchend', te); };
  }, [next, prev]);

  const slides = [
    Slide01Hero,          // 01
    Slide02About,         // 02
    Slide03Vision,        // 03
    Slide04Values,        // 04
    SlidePartners,        // 05 — Partners (moved to front, highlight)
    Slide05Highlights,    // 06
    SlideBCoin,           // 07 — NEW: About BCoin
    Slide06Chain,         // 08 — BEP-20 + USDT + BCoin
    SlidePayment,         // 09 — NEW: Payment Methods (10% BCoin + 90% USDT)
    Slide07Packages,      // 10
    Slide08Income,        // 11
    Slide09Distribution,  // 12
    Slide10X6Board,       // 13
    Slide11DirectIncome,  // 14
    Slide12LevelIncome,   // 15
    SlidePool1,           // 16 — Crimson weekly
    SlidePool2,           // 17 — Golden weekly
    SlidePool3,           // 18 — Royal monthly
    SlidePool4,           // 19 — Sovereign monthly
    SlideNFT,             // 20
    SlideCeiling,         // 21
    SlideRetopup,         // 22
    SlideUserJourney,     // 23
    SlideTerms,           // 24
    SlideSummary,         // 25
    SlideCTA,             // 26
    SlideThankYou,        // 27
  ];

  const SlideComponent = slides[currentSlide] || Slide01Hero;

  if (loading) return <Loader progress={loadProgress} />;

  return (
    <div className="app">
      <Background />
      <div id="slide-container" style={{position:'absolute',inset:0,overflow:'hidden'}}>
        <SlideWrapper
          key={currentSlide}
          direction={direction}
          transitioning={transitioning}
        >
          <SlideComponent  slideNumber={currentSlide + 1} totalSlides={TOTAL_SLIDES} pdfMode={pdfMode} />
        </SlideWrapper>
      </div>
      <Controls
        current={currentSlide}
        total={TOTAL_SLIDES}
        onNext={next}
        onPrev={prev}
        onGoTo={goTo}
        
        
      />
      <TTSButton currentSlide={currentSlide} />
    </div>
  );
}
